<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iOONlG/tc-custom/9781467428798.jpg?1730407464020" alt="This image is the cover for the book Biblical Exegesis in the Apostolic Period"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Biblical Exegesis in the Apostolic Period
      </h1>
      <p class="bookDescription body article font2">
        <p>The discovery of the Dead Sea Scrolls, the Nag Hammadi texts, and new Targums has greatly increased scholarly interest in the relationship between the New Testament and first -century Judaism. This critically acclaimed study by Richard Longenecker sheds light on this relationship by exploring the methods the earliest Christians used to interpret the Old Testament. By comparing the first Christian writings with Jewish documents from the same period, Longenecker helps to discern both the key differences between Christianity and Judaism and the Judaic roots of the Christian faith.<br/><br/> This revised edition of <i>Biblical Exegesis in the Apostolic Period</i> brings Longenecker's valued work up to date with current research in this important field of study.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard N. Longenecker
      </h2>
      
      <p class="authorDescription body article">&#160;<B>Richard N. Longenecker</B>&#160;(1930&ndash;2021) was a distinguished New Testament scholar who taught for many years at Wycliffe College, University of Toronto. He was the author of numerous books, including&#160;<I>Paul, Apostle of Liberty; The Christology of Early Jewish Christianity; New Testament Social Ethics for Today; Introducing Romans: Critical Issues in Paul&#39;s Most Famous Letter</I>, and the New International Greek Testament Commentary volume on Romans.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21ae8eda